import { IStore, IState } from '@/interfaces';
import actions from './actions';
import getters from './getters';
import mutations from './mutations';
import { reactive } from 'vue';
import { initialState } from './state';

// Factory function to create a new store instance
// eslint-disable-next-line prefer-arrow/prefer-arrow-functions
export function createStore(): IStore {
	return {
		state: reactive(JSON.parse(JSON.stringify(initialState)) as IState),
		getters,
		mutations,
		actions
	};
}

// Create a default store instance for testing
const store = createStore();

export default store;